import {priority} from '@priority-software/priority-proto-api/lib/nform';
import {getConnection, getCurSession} from '../../../../../_shared/GWTBridge/invoke/bpm/bpmMain';
import {BpmAlertResponse} from './types';
import {buildServerCall} from '../../../../../services/wcfService';

export const BPMCheckAlertExpr = async (expr: string, id: string) => {
    const methodName = 'BPMCheckAlertExpr';
    const reason = 'BPMCheckAlertExpr';

    const parameters = {
        session: [getCurSession()],
        id: [id],
        expr: [expr]
    };

    const res: BpmAlertResponse = await buildServerCall(
        methodName,
        parameters,
        reason,
        true,
        getConnection
    );

    const BPM = res?.BPM?.[0] as {checkexpr: '1' | '0'};

    return new priority.netitems.form.AlertCheckExprRs({ValidExpr: BPM.checkexpr === '1'});
};
